import { convert } from '../../platform/Convert';
import { HasProperties, PropertyDefinition, PropertyValueType } from './Interfaces';
import { Manifest } from './Manifest';

// TODO: Add validator support
const primitiveComponentPropertyValueType = <T>(type: string, defau1tDefau1t: T) => Object.freeze({
    name: type,
    fromString(value: string) {
        return convert(value, type);
    },
    serialize(value: T): any {
        return value ?? defau1tDefau1t;
    },
    deserialize(value: any, defau1t?: T): T {
        if (typeof (value) === type && value !== '') {
            return value;
        }
        if (typeof (value) === 'string' && type !== 'string') {
            const [ok, newValue] = convert(value, type);
            if (ok) return newValue;
        }
        return defau1t ?? defau1tDefau1t;
    },
});

const arrayPrimitiveComponentPropertyValueType = <T>(type: string, defau1tDefau1t: T[]) => Object.freeze({
    name: type,
    fromString(value: string) {
        return JSON.parse(value);
    },
    serialize(value: T[]): any {
        return value ?? defau1tDefau1t;
    },
    deserialize(value: any, defau1t?: T[]): T[] {
        return value ?? defau1t ?? defau1tDefau1t;
    },
});

const builtInPropertyValueTypes = {
    string: primitiveComponentPropertyValueType<string>('string', ''),
    'string[]': arrayPrimitiveComponentPropertyValueType<string>('string', []),
    number: primitiveComponentPropertyValueType<number>('number', 0),
    'number[]': arrayPrimitiveComponentPropertyValueType<number>('number', []),
    boolean: primitiveComponentPropertyValueType<boolean>('boolean', false),
    any: primitiveComponentPropertyValueType<any>('any', null),
};

export const resolvePropertyValueType = (input: unknown): PropertyValueType<unknown> => {
    if (!input) input = 'string';
    return typeof (input) === 'string'
        ? (builtInPropertyValueTypes as any)[input]
        : input;
};

export function property(def: PropertyDefinition = {}): PropertyDecorator {
    return ({ constructor }: any, name: string | symbol) => {
        // Prevent use on symbol properties
        if (typeof (name) !== 'string') throw new Error('property failure: Cannot use symbol as property key.');
        // Resolve value type
        const type = resolvePropertyValueType(def.type);
        // Create descriptor
        const pd = Object.assign({ name, default: null }, def, { type }) as any;
        // Register on type
        Manifest.registerProperty(constructor, pd);
        // Return property override
        return {
            configurable: false,
            get(this: HasProperties) {
                return this.get(pd.name);
            },
            set(this: HasProperties, value: unknown) {
                this.set(pd.name, value);
            },
        };
    };
}
